import { Component, OnInit, Injectable, ViewChild, ElementRef } from '@angular/core'
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { DbService } from '../../services/db.service'
//import { getPluralCategory } from '@angular/common/src/i18n/localization'
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap'
import { Subscription } from 'rxjs'
import { Booking, Contact, Tag } from '../../interfaces/booking'
import { BookingObject } from '../../interfaces/booking-object'
import { Combination } from '../../interfaces/combination'
import { Confirmation } from '../../interfaces/confirmation'
import { Event } from '../../interfaces/event'

import { Setting } from '../../interfaces/setting'
import { Shift } from '../../interfaces/shift'
import { Resource } from '../../interfaces/resource'
import { Price } from '../../interfaces/price'
import * as uuid from 'uuid/v1'
import notify from 'devextreme/ui/notify'
import IntervalTree from 'node-interval-tree'
import { Router } from '@angular/router'
import { ModalCheckout, Event as BamboraEvent } from '@bambora/checkout-sdk-web'

import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import * as moment from 'moment'
import { NGB_DATEPICKER_18N_FACTORY } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-i18n'

declare var encode: Function

const now = new Date()

const I18N_VALUES = {
  'se': {
    weekdays: ['Må', 'Ti', 'On', 'To', 'Fr', 'Lö', 'Sö'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Juni', 'Juli', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec'],
  },
  'en': {
    weekdays: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
    months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  }

}

@Injectable()
export class I18n {
  language = 'se'
}

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private _i18n: I18n) {
    super();
  }

  getWeekdayShortName(weekday: number): string {
    return I18N_VALUES[this._i18n.language].weekdays[weekday - 1]
  }
  getMonthShortName(month: number): string {
    return I18N_VALUES[this._i18n.language].months[month - 1]
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month)
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`
  }
}

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.css'],
  providers: [I18n, {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n}]
})
export class BookingComponent implements OnInit {

  @ViewChild('container') container;
  @ViewChild('kod') kod: ElementRef;
  @ViewChild('fnamn') fnamn: ElementRef;
  @ViewChild('mobil') mobil: ElementRef;
  @ViewChild('sammanst') sammanst: ElementRef;
  @ViewChild('dp') dp

  routeSubscription
  busSubscription
  private url = 'https://db.bookmakeronline.se:3443'
  accordionItems = []
  resources: Resource[] = []
  bookings = []
  bookingObjects: BookingObject[] = []
  
  combinations: Combination[] = []
  confirmations: Confirmation[] = []
  tags: Tag[] = []
  prices: Price[] = []
  events: Event[] = []
  allEvents: Event[] = []
  shifts: Shift[] = []
  singleResource
  dpModel: NgbDateStruct = { year: now.getFullYear(), month: now.getMonth() + 1, day: now.getDate() }
  minDate: NgbDateStruct
  maxDate: NgbDateStruct
  months = 2
  dayOfWeek = ''
  subscription: Subscription
  oo
  error = false
  steg = 1
  xkod = ''
  bkod = ''
  swishable = false
  timeout = 480
  logo = { name: '', data: ''}
  webOptions = []
  webBlocks = []
  extraprod1 = 0
  extraprod2 = 0
  extraprod3 = 0

  useTerms = false
  termsChecked = false

  booking: Booking = { id: uuid(), nr: 0, workday: '', contact: { id: '', fnamn: '', enamn: '', company: '', mobil: '', epost: '', system: '' }, internalinfo: '', persons: 0, deleted: false, signature: 'web', locked: false, bookingItems: [], collapsedItems: [], menuItems: [], tags: [], unfinished: false, system: '', idGroupBooking: '', groupBookingDay: 0, groupBookingPaid: false, idGroupBookingStatus: '', idGroupBookingTemplate: '', invoiceinfo: '', deliveryinfo: '', offert: false, idWaiter: '' }
  contact: Contact = { id: uuid(), fnamn: "", enamn: "", company: '', epost: "", mobil: "", system: '' };
  
  public mobilForm: FormGroup
  public contactForm: FormGroup

  final = false

  useBambora = false

  showBB = true

  constructor(public db: DbService, private route: ActivatedRoute, private fb: FormBuilder, private router: Router, private _i18n: I18n) {

    if (window.location.search == '?l=en') {
      this.db.idLang = 1
      this._i18n.language = 'en'
    }

    // Create reactive forms
    this.mobilForm = fb.group({
      mobil: [{ value: null, disabled: this.steg > 2 }, [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]]
    });

    this.contactForm = fb.group({
      bkod: [{ value: null, disabled: true }, [Validators.required, Validators.minLength(4), Validators.maxLength(4)]],
      fnamn: [{ value: null, disabled: true }, Validators.required],
      enamn: [{ value: null, disabled: true }, Validators.required],
      epost: [{ value: null, disabled: true }, [Validators.required, Validators.email]],
      info: [{ value: null, disabled: true }]
    });

    this.busSubscription = this.db.msgBusGetMessage().subscribe(message => {
      
      if (message.text == 'sammanst') {
        setTimeout(() => {
          this.sammanst.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" })
        }, 600)
      }

    })

    // Create timer
    setInterval(() => { this.timerInterval(); }, 1000);    

    
    
  }

  ngOnInit() {
    
    // Set min and max date for calender
    this.minDate = this.dpModel
    this.maxDate = this.minDate

    this.subscription = this.db.getMessages().subscribe(message => {
      this.messageHandler(message)
    })
    
    this.routeSubscription = this.route.params.subscribe(params => {
      
      if (typeof params.system === 'undefined') {
        this.error = true
      }
      this.db.system = params.system
      if (this.db.system == 'viskanfusion') this.db.system = 'viskanvinbar'
      if (this.db.system == 'krogochco') this.db.system = 'harlju'
      if (this.db.system == 'nomad') this.db.system = 'queens'
      
      if (['bird'].includes(this.db.system)) this.showBB = false

      this.singleResource = params.resource

      this.db.bg = "https://cdn.bokad.se/" + this.db.system + "/bg.jpg"      

      if (this.db.system == 'maltohumle') {
        this.db.subSystem = 'maltohumle'
        this.db.system = 'storan'
      }

      if (this.db.system == 'borgmastarn') {
        this.db.subSystem = 'borgmastarn'
        this.db.system = 'bonbon'
      }

      if (this.db.system == 'arriba') {
        this.db.subSystem = 'arriba'
        this.db.system = '1854'
      }

      if (this.db.system == 'aperitivo') {
        this.db.subSystem = 'aperitivo'
        this.db.system = '1854'
      }


      this.db.sendMessage('login', { system: this.db.system, user: 'web', pass: '' })
      if (this.db.system == 'hugo') this.months = 1

      this.db.browserInfo.id = uuid()
      this.db.browserInfo.ts = moment().toDate()  
      this.db.browserInfo.version = this.db.version
      this.db.sendMessage('dbm', { 
        cmd: 'save', 
        table: 'browsers', 
        system: this.db.system,
        data: this.db.browserInfo,
        id: this.db.browserInfo.id
      })        
      
    })
    
    if (
      this.db.browserInfo.device == 'iphone' ||
      this.db.browserInfo.device == 'android' ||
      this.db.browserInfo.browser == 'ie'
    ) this.months = 1
    
    //this.months = 1 // Force mobile mode for debugging

  }

  ngOnDestroy() {
    this.routeSubscription.unsubscribe()
    this.subscription.unsubscribe()
    this.busSubscription.unsubscribe()
  }

  setLang(id) {

    this.db.idLang = id

    if (id == 0) this._i18n.language = 'se'
    if (id == 1) this._i18n.language = 'en'

    this.dp.navigateTo(this.dpModel)

  }

  messageHandler(message) {

    //console.log('mh', message)

    if (message.table == 'openhours') {

      this.oo = <any>message.data
      //console.log('oo', this.oo)

      this.accordionItems.filter(a => a.nr > 0).forEach(a => {
        this.resources.filter(r => a.id == r.id).forEach(r => {

          if (r.ohid == 1) { a.open = this.oo.open1; a.close = this.oo.close1 }
          if (r.ohid == 2) { a.open = this.oo.open2; a.close = this.oo.close2 }
          if (r.ohid == 3) { a.open = this.oo.open3; a.close = this.oo.close3 }
          if (r.ohid == 4) { a.open = this.oo.open4; a.close = this.oo.close4 }
          if (r.ohid == 5) { a.open = this.oo.open5; a.close = this.oo.close5 }

          if (r.idcalendar) {
            
            //console.log(r.name, 'has cal')

            let rules: any = this.db.getCalRules(r.idcalendar, this.db.workday)
            
            if (rules && rules.closed) this.db.closedMessage = rules.ruleName

            let min = 9999
            let max = 0
            let dur = 0

            rules.bookableTimes.forEach(bt => {
              if (bt.start < min) min = bt.start
              if (bt.end > max) {
                max = bt.end
                dur = bt.duration || 0
              }
            })

            if (!rules.bookableTimes.length) min = 0

            a.open = min
            a.close = max
            a.duration = dur
            
          }

        })
      })
      
    }

    if (message.table == 'bookings') {

      //console.log('got bookings', message.data)

      if (!this.final) {
        this.bookings = <any>message.data
        this.bookings.push(this.booking)
        this.db.msgBusSendMessage('bookingschanged')  
      }

      if (this.final) {

        //console.log('final')

        var bookings: Booking[] = <any>message.data
        var overlap = false

        // Create ivt for all (other) bookings
        var ivt = new IntervalTree()
        bookings.filter(b => !b.deleted).forEach(b => {
          b.bookingItems.forEach(bi => {
            //console.log(bi.start, bi.start + bi.duration - 1)
            if (bi.start < bi.start + bi.duration - 1) ivt.insert(bi.start, bi.start + bi.duration - 1, bi.idBookingObject)
          })
        })

        //console.log(this.booking.bookingItems)
        //console.log(ivt)

        // Check our bookingItems for overlap
        //console.log(this.booking)
        this.booking.bookingItems.forEach(bi => {
          if (typeof bi.duration === 'string') bi.duration = +bi.duration
          ivt.search(bi.start, bi.start + bi.duration -1).forEach(i => {
            if (i == bi.idBookingObject) {
              //console.log('Overlap!', bi)
              overlap = true
            }
          })
        })

        if (overlap) {
          this.steg = 6
        } else {
          this.slutfor()
        }

      }

    }

    if (message.table == 'resources') {
      
      this.resources = <any>message.data

      this.resources.forEach(r => {
        if (typeof r.durations === 'undefined') r.durations = []
        r.durations = r.durations.filter(r => r.active)
        r.durations.sort(function (a, b) { if (a.sortorder < b.sortorder) return -1; if (a.sortorder > b.sortorder) return 1; return 0; })
      })

      
      // Add accordion items
      var nr = 1
      if (this.singleResource) this.resources = this.resources.filter(resource => resource.id == this.singleResource)
      this.resources.filter(r => r.name != 'Catering' && r.web).sort(function (a, b) { if (a.sortorder < b.sortorder) return -1; if (a.sortorder > b.sortorder) return 1; return 0; }).forEach(resource => {
        this.accordionItems.push({nr: nr++, id: resource.id, text: resource.name, open: 0, close: 0, resource: resource })
      })

      //let maltoHumleIdResource = '056239a0-8615-11ea-8924-336bb78f231d'
      //if (this.db.system == 'storan' && !this.db.subSystem) this.accordionItems = this.accordionItems.filter(ai => ai.id != maltoHumleIdResource)
      //if (this.db.subSystem == 'borgmastarn') this.accordionItems = this.accordionItems.filter(ai => ai.id == maltoHumleIdResource)

      let borgmastarnIdResource = 'a8f97f10-1246-11f1-80c0-dfe17dd4ca22'
      if (this.db.system == 'bonbon' && !this.db.subSystem) this.accordionItems = this.accordionItems.filter(ai => ai.id != borgmastarnIdResource)
      if (this.db.subSystem == 'borgmastarn') this.accordionItems = this.accordionItems.filter(ai => ai.id == borgmastarnIdResource)

      let arribaIdResource = '4cf776c0-77df-11ea-b90d-895ce4af2959'
      if (this.db.system == '1854' && !this.db.subSystem) this.accordionItems = this.accordionItems.filter(ai => ai.id != arribaIdResource)
      if (this.db.subSystem == 'arriba') this.accordionItems = this.accordionItems.filter(ai => ai.id == arribaIdResource)

      let aperitivoIdResource = '666bfbb0-aa93-11ec-b924-8d5306aec337'
      if (this.db.system == '1854' && !this.db.subSystem) this.accordionItems = this.accordionItems.filter(ai => ai.id != aperitivoIdResource)
      if (this.db.subSystem == 'aperitivo') this.accordionItems = this.accordionItems.filter(ai => ai.id == aperitivoIdResource)

      this.calSel()

      if (this.db.selectDate) setTimeout(() => {
        this.gotoDate(this.db.selectDate)
      }, 500)

    }

    if (message.table == 'settings') {
      //console.log(message.data)
      this.db.settings = <Setting[]>message.data
      this.db.setting.webtext1 = this.db.getSetting('webtext1', '')
      this.db.setting.webtext2 = this.db.getSetting('webtext2', '')
      this.db.setting.webtext3 = this.db.getSetting('webtext3', '')
      this.db.setting.weblogo = this.db.getSetting('weblogo', '')
      this.db.setting.return = this.db.getSetting('webreturn', '')
      this.db.setting.verify = this.db.getSetting('webverify', '1')
      this.db.setting.karens = this.db.getSetting('webkarens', '60')
      this.db.setting.webstop = +this.db.getSetting('webstop', '0')
      this.db.setting.dagar = this.db.getSetting('webdagar', '30')
      this.db.setting.infobox = this.db.getSetting('webinfobox', '0')
      this.db.setting.bottom = this.db.getSetting('webbottom', '')
      this.db.setting.swishpay = +this.db.getSetting('webswishpay', '0')
      this.db.setting.enableQueue = +this.db.getSetting('webqueue', '0')
      this.db.setting.avismail = this.db.getSetting('webavismail', '')
      this.db.setting.avissms = this.db.getSetting('webavissms', '')
      this.db.setting.showEvents = +this.db.getSetting('webshowevents', '0')
      this.db.setting.terms = this.db.getSetting('webterms', '')

      if (this.db.setting.terms != '') this.useTerms = true


      if (this.db.subSystem == 'borgmastarn') this.db.setting.weblogo = 'mhlogo.png'
      if (this.db.subSystem == 'arriba') this.db.setting.weblogo = 'arribalogo.png'
      if (this.db.subSystem == 'aperitivo') this.db.setting.weblogo = 'Aperitivo-logo-350.png'

      var wo = this.db.getSetting('weboptions', '')
      if (wo.length) {
        var wop = wo.split(',')
        wop.forEach(w => {
          this.webOptions.push({ cb: w.split('|')[0], cbv: false, tb: (w.split('|')[1] != '-'), tbv: w.split('|')[1], disabled: true })
        })
      }

      var d = new Date().addDays(+this.db.setting.dagar)
      this.maxDate = { year: d.getFullYear(), month: d.getMonth() + 1, day: d.getDate() }

      if (this.db.getSetting('webvalidatemobile', '1')) {
        this.mobilForm = this.fb.group({
          mobil: [{ value: null, disabled: this.steg > 2 }, [Validators.required,  Validators.pattern('^[0-9]*$')]]
        })
      }
  
      let cmd = { cmd: 'webfile', system: this.db.system, token: this.db.token, name: this.db.setting.weblogo }
      encode(cmd)
      this.db.sendMessage('db', JSON.stringify(cmd))

    }

    if (message.table == 'files') {
      this.logo = <any>message.data
    }    

    if (message.table == 'webblocks') {
      this.webBlocks.push(... <any[]>message.data)
    }  

    if (message.table == 'staticwebblocks') {
      this.webBlocks.push(... <any[]>message.data)
    }  

    if (message.table == 'shifts') {
      this.shifts = <any[]>message.data
    }  

    if (message.action == 'login') {

      this.getData()
      
      // Get resources
      //this.db.sendMessage('db', JSON.stringify({ cmd: 'webres', system: this.db.system, token: this.db.token }))
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'resources', 
        condition: { system: this.db.system },
        tableSuffix: '',
        sort: {},
        limit: 0
      })

      // Settings
      //this.db.sendMessage('db', JSON.stringify({ cmd: 'webset', system: this.db.system, token: this.db.token }))
      this.db.sendMessage('dbm', { 
        cmd: 'find', 
        table: 'settings', 
        condition: { system: this.db.system, sortorder: { $gte: 1000 } },
        projection: { _id: 0, name: 1, value: 1 },
        tableSuffix: '',
        sort: {},
        limit: 0
      })
      
    }

    if (message.table == 'contact') {
      //console.log('Got', message)
      //console.log('data len', message.data.length)
      if (message.data.length == 1) {
        this.contact = message.data[0]
        /*
        this.contactForm.value.fnamn = this.contact.fnamn
        this.contactForm.value.enamn = this.contact.enamn
        this.contactForm.value.epost = this.contact.epost
        */

        if (this.db.setting.verify != '1') {
          this.contactForm.setValue({
            fnamn: this.contact.fnamn,
            enamn: this.contact.enamn,
            epost: this.contact.epost,
            info: '',
            bkod: '0000'
          })
        }
        
      } else {
        // TODO console.log('add contact')
        this.contact.mobil = this.mobilForm.value.mobil
        this.contact.system = this.db.system

        let cmd = { 
          cmd: 'addcontact',
          contact: this.contact,
          system: this.db.system,
          token: this.db.token
        }
        encode(cmd)
        this.db.sendMessage('db', JSON.stringify(cmd))          

      }
    }

    if (message.table == 'events') {
      
      var tmpEvents: Event[] = []
      this.events = []
      this.allEvents = []
      tmpEvents = <any>message.data

      if (this.db.subSystem == 'borgmastarn') tmpEvents = tmpEvents.filter(te => te.idResource == '056239a0-8615-11ea-8924-336bb78f231d')
      if (this.db.subSystem == 'storan') tmpEvents = tmpEvents.filter(te => te.idResource != '056239a0-8615-11ea-8924-336bb78f231d')

      //
      // Expand repeating events
      tmpEvents.filter(e => e.repeat && e.active).forEach(e => {

        if (!e.eventType) e.eventType = 1

        var startDate = new Date(+e.workday.substr(0, 4), +e.workday.substr(5, 2) - 1, +e.workday.substr(8,2))
        var endDate = new Date(+e.enddate.substr(0, 4), +e.enddate.substr(5, 2) - 1, +e.enddate.substr(8,2))
        //startDate.setDate(startDate.getDate() + 1)

        var counter = 0
        while (startDate <= endDate && counter++ < 365) {
          
          if (e.weekdays.indexOf(startDate.getDay()) != -1) {
            tmpEvents.push({
              id: e.id,
              idResource: e.idResource,
              idConfirmation: e.idConfirmation || '',
              workday: startDate.format('YYYY-MM-DD'),
              eventType: e.eventType,
              start: e.start,
              duration: e.duration,
              prebooking: e.prebooking,
              zones: e.zones,
              descr: e.descr,
              info: e.info,
              weekdays: [],
              repeat: false,
              enddate: '',
              api: e.api,
              ppi: e.ppi,
              csi: e.csi,
              minPersons: e.minPersons || 1,
              karens: e.karens || 0,
              tags: e.tags || [],
              color: e.color,
              textcolor: e.textcolor,
              deleted: false,
              active: e.active,
              allowedItems: e.allowedItems || [],
              allowedStarts: e.allowedStarts || [],
              mark: e.mark || false
            })
          }
          startDate.setDate(startDate.getDate() + 1)
        }

      })
      tmpEvents = tmpEvents.filter(e => !e.repeat && e.active)
      
      //this.allEvents = [...tmpEvents].filter(ae => ae.workday >= this.db.workday)
      tmpEvents.forEach(te => {

        let diff = moment(te.workday).diff(moment(), 'days')
        if (diff < +this.db.setting.dagar && te.workday >= moment().format('YYYY-MM-DD')) this.allEvents.push(te)

      })

      this.allEvents.sort(function (a, b) { 
        if (a.workday < b.workday) return -1
        if (a.workday > b.workday) return 1
        if (a.start < b.start) return -1
        if (a.start > b.start) return 1 
        return 0; 
      });

      tmpEvents.filter(te => te.workday == this.db.workday).forEach(te => {
        
        te["resource"] = {}
        
        this.resources.filter(r => r.id == te.idResource).forEach(r => {
          te["resource"] = r
        })

        // Push event if not today and event time has passed
        //var d = new Date();
        //if (!(this.db.isToday() && d.getHours() * 60 + d.getMinutes() + 30 > te.start)) this.events.push(te)
        this.events.push(te)
      })
      this.events.sort(function (a, b) { if (a.start < b.start) return -1; if (a.start > b.start) return 1; return 0; });
    }

  }

  getData() {

    Promise.all([

      this.db.sendMessagePromise('mget', { table: 'calendars', system: this.db.system, condition: { system: this.db.system, active: true }, projection: {}, sort: { sortorder: 1 }, limit: 0 }),
      this.db.sendMessagePromise('mget', { table: 'tags', system: this.db.system, condition: { system: this.db.system, active: true }, projection: {}, sort: { sortorder: 1 }, limit: 0 }),
      this.db.sendMessagePromise('mget', { table: 'prices', system: this.db.system, condition: { system: this.db.system }, projection: {}, sort: { }, limit: 0 }),
      this.db.sendMessagePromise('mget', { table: 'bookingobjects', system: this.db.system, condition: { system: this.db.system }, projection: {}, sort: { }, limit: 0 }),
      this.db.sendMessagePromise('mget', { table: 'combinations', system: this.db.system, condition: { system: this.db.system }, projection: {}, sort: { }, limit: 0 }),
      this.db.sendMessagePromise('mget', { table: 'confirmations', system: this.db.system, condition: { system: this.db.system }, projection: {}, sort: { }, limit: 0 })

    ]).then((results: any) => {

      // Calendars
      this.db.calendars = results[0].data
      //console.log('Calendars', this.calendars)

      // Tags
      this.tags = results[1].data
      // console.log('Tags', this.tags)

      // Prices
      this.prices = results[2].data
      // console.log('Prices', this.prices)

      // Bookingobjects
      this.bookingObjects = results[3].data
      // console.log('Bookingobjects', this.bookingObjects)
      
      // Combinations
      this.combinations = results[4].data
      // console.log('Combinations', this.combinations)

      // Confirmations
      this.confirmations = results[5].data
      // console.log('Confirmations', this.confirmations)
      
    })    
  }

  timerInterval() {
    if (this.timeout) this.timeout--
    if (this.timeout == 60) notify('Bokningen måste slutföras inom 60 sekunder!', 'error', 3000)
    if (!this.timeout) this.suicide()
  }

  suicide() {

    setTimeout(() => { location.assign(this.db.setting.return); }, 3000)

  }

  isEvent(date) {

    //if (this.db.system != 'hif') return
    if (this.db.system == 'hif' || this.db.system == 'oh') {

      let month = date.month.toString()
      if (month.length == 1) month = '0' + month
      let day = date.day.toString()
      if (day.length == 1) day = '0' + day
      let d = date.year + '-' + month + '-' + day

      return this.allEvents.filter(ae => ae.workday == d).length

    }

  }

  clickEvent(e) {
    this.dpModel = { year: +e.workday.substr(0, 4), month: +e.workday.substr(5, 2), day: +e.workday.substr(8, 2) }
    this.dp.navigateTo(this.dpModel)
    this.calSel()
  }

  gotoDate(workday) {
    
    this.dpModel = { year: +workday.substr(0, 4), month: +workday.substr(5, 2), day: +workday.substr(8, 2) }
    this.dp.navigateTo(this.dpModel)
    this.calSel()

  }

  calSel() {
    
    var month = this.dpModel.month.toString()
    if (month.length == 1) month = '0' + month
    var day = this.dpModel.day.toString()
    if (day.length == 1) day = '0' + day
    this.db.workday = this.dpModel.year + "-" + month + "-" + day
    this.booking.workday = this.db.workday
    this.db.closedMessage = ''

    //let cmd1 = { cmd: 'weboo', system: this.db.system, token: this.db.token, workday: this.db.workday }
    //encode(cmd1)
    //this.db.sendMessage('db', JSON.stringify(cmd1))
    this.db.sendMessage('dbm', { 
      cmd: 'find', 
      table: 'openhours', 
      condition: { system: this.db.system, workday: this.db.workday },
      tableSuffix: '' ,
      sort: {},
      limit: 0
    })

    //let cmd2 = { cmd: 'webbo', system: this.db.system, token: this.db.token, workday: this.db.workday }
    //encode(cmd2)
    //this.db.sendMessage('db', JSON.stringify(cmd2))
    this.db.sendMessage('dbm', { 
      cmd: 'find', 
      table: 'bookings', 
      condition: { system: this.db.system, workday: this.db.workday, deleted: false },
      tableSuffix: '' ,
      sort: {},
      limit: 0
    })
    
    //let cmd3 = { cmd: 'getall', system: this.db.system, token: this.db.token, workday: this.db.workday, table: 'events', sort: { sortorder: 1 } }
    //encode(cmd3)
    //this.db.sendMessage('db', JSON.stringify(cmd3))
    this.db.sendMessage('dbm', { 
      cmd: 'find', 
      table: 'events', 
      condition: { system: this.db.system },
      tableSuffix: '',
      sort: { sortorder: 1 },
      limit: 0
    })


    //console.log('calSel', this.db.workday)
    var days = ["Söndag", "Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag", "Lördag"]
    var d = new Date(this.db.workday)
    this.dayOfWeek = days[d.getDay()]
    var daynumber = d.getDay()

    this.webBlocks = []

    this.db.sendMessage('dbm', { 
      cmd: 'find', 
      table: 'webblocks', 
      condition: { system: this.db.system, workday: this.db.workday, blocked: true },
      tableSuffix: '' ,
      sort: {},
      limit: 0
    })

    this.db.sendMessage('dbm', { 
      cmd: 'find', 
      table: 'staticwebblocks', 
      condition: { system: this.db.system, day: moment(this.db.workday).locale('sv').weekday() },
      tableSuffix: '' ,
      sort: {},
      limit: 0
    })

    this.db.sendMessage('dbm', { 
      cmd: 'find', 
      table: 'shifts', 
      condition: { system: this.db.system, active: true, weekdays: daynumber },
      tableSuffix: '' ,
      sort: {},
      limit: 0
    })

    this.db.msgBusSendMessage('calchange')

    //if (this.db.system == 'cioccolata' && this.db.workday >= '2018-12-08' && this.dayOfWeek == 'Lördag') {
    //  notify('Nu erbjuder vi shoppingbuffé för 129 kr på lördagar i stället för brunch, läs mer på vår hemsida.', 'success', 3000)
    //}

  }

  avbryt() {
    this.booking.bookingItems = []
    this.db.collapseBookingItems(this.booking, this.bookingObjects)
    this.booking.menuItems = []
    this.booking.unfinished = false
    this.db.msgBusSendMessage('cancel')
    this.db.panel1Expanded = true
  }

  proceed() {

    if (this.db.system == 'hif' && this.booking.collapsedItems.filter(ci => ci.idResource == 'b6deb1f8-e39a-653f-976b-a55fe1eb0442').length) this.webOptions = []
    //if (this.db.system == 'oh' && !this.booking.collapsedItems.filter(ci => ci.idResource == 'fd0e9f70-c7db-11e9-935f-c9fdc4b0eb41').length) this.webOptions = []
    
    this.setPrices()
    this.steg = 2
    setTimeout(() => { this.mobil.nativeElement.focus() }, 500)
    
    if (this.db.setting.verify != '1') {
      this.contactForm.get('fnamn').enable()
      this.contactForm.get('enamn').enable()
      this.contactForm.get('epost').enable()    
      this.contactForm.get('info').enable()
      this.contactForm.get('bkod').enable()    
    }

  }

  skickakod() {

    if (this.db.setting.verify != '1') return

    this.xkod = this.getRandomInt(1000, 9999).toString();
    this.contact.mobil = this.mobilForm.value.mobil;
    var fixednr = "+46" + this.contact.mobil.substring(1);
    var smsConfirmation = this.getConfirmation(1)
    //this.msg.sendMessage("sms|" + fixednr + "|Säkerhetskod " + this.xkod + '|' + this.db.booking.uuid);
    
    var msg = "Säkerhetskod " + this.xkod
    var smsObj = {
      cmd: 'sendsms',
      id: this.booking.id,
      sender: smsConfirmation.subject,
      to: fixednr,
      message: msg,
      system: this.db.system
    }

    //console.log('SMS-Obj', smsObj)
    if (!this.db.debug) this.db.sendMessage('send', smsObj)

    // Get contact
    let cmd = { cmd: 'webgetcontact', system: this.db.system, token: this.db.token, mobil: this.mobilForm.value.mobil }
    encode(cmd)
    this.db.sendMessage('db', JSON.stringify(cmd))

    this.steg = 3

    this.contactForm.get('bkod').enable()

    setTimeout(() => {
      this.kod.nativeElement.focus()
      this.mobilForm.get('mobil').disable()
    }, 500)

  }

  mobilkeyup() {
    if (this.db.setting.verify == '1') return

    if (this.mobilForm.valid && this.mobilForm.value.mobil.length == 10) {

      //console.log('Mobil valid!')

      this.steg = 4
      
      this.contactForm.get('fnamn').enable()
      this.contactForm.get('enamn').enable()
      this.contactForm.get('epost').enable()    
      this.contactForm.get('info').enable()
      this.contactForm.get('bkod').enable()    
      this.webOptions.forEach(wo => { wo.disabled = false })

          this.contactForm.setValue({
            fnamn: '',
            enamn: '',
            epost: '',
            info: '',
            bkod: '0000'
          })      

      // Get contact
      let cmd = { cmd: 'webgetcontact', system: this.db.system, token: this.db.token, mobil: this.mobilForm.value.mobil }
      encode(cmd)
      this.db.sendMessage('db', JSON.stringify(cmd))

      setTimeout(() => {
        this.fnamn.nativeElement.focus();
      }, 500);

    }
  }

  kodkeyup() {
    if (this.contactForm.value.bkod == this.xkod || this.contactForm.value.bkod == "2076") {

      if (this.contactForm.value.bkod == "2076") this.xkod = "2076";
      this.bkod = this.contactForm.value.bkod;

      this.steg = 4;

      this.contactForm.get('fnamn').enable();
      this.contactForm.get('enamn').enable();
      this.contactForm.get('epost').enable();
      this.contactForm.get('info').enable()
      this.webOptions.forEach(wo => { wo.disabled = false })

      this.contactForm.setValue({
        fnamn: this.contact.fnamn,
        enamn: this.contact.enamn,
        epost: this.contact.epost,
        info: '',
        bkod: this.xkod
      });

      // Validerad mobil, skapa cookie
      document.cookie = "u=" + this.contact.mobil + ";max-age=" + (60*60*24*365).toString();

      setTimeout(() => {
        this.fnamn.nativeElement.focus();
        this.contactForm.get('bkod').disable();
      }, 500);

    }
  }

  getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  trySlutfor() {
    this.final = true
    //let cmd = { cmd: 'webbo', system: this.db.system, token: this.db.token, workday: this.db.workday }
    //encode(cmd)
    //this.db.sendMessage('db', JSON.stringify(cmd))
    this.db.sendMessage('dbm', { 
      cmd: 'find', 
      table: 'bookings', 
      condition: { system: this.db.system, workday: this.db.workday, deleted: false },
      tableSuffix: '' ,
      sort: {},
      limit: 0
    })
  }

  slutfor() {

    this.contactForm.enable()
    this.mobilForm.enable()
    
    if (!this.mobilForm.value.mobil || this.mobilForm.value.mobil.length < 9) { notify('Felaktigt telefonnummer', 'error', 2000); return; }
    if (!this.contactForm.value.fnamn) { notify('Felaktigt förnamn', 'error', 2000); return; }
    if (!this.contactForm.value.enamn) { notify('Felaktigt efternamn', 'error', 2000); return; }
    if (!this.contactForm.value.epost) { notify('Felaktig e-post', 'error', 2000); return; }

    if (this.contact.fnamn != this.contactForm.value.fnamn || this.contact.enamn != this.contactForm.value.enamn || this.contact.epost != this.contactForm.value.epost) {
      
      //if (this.db.debug) console.log("Uppdaterar kontakt")
      this.contact.fnamn = this.contactForm.value.fnamn
      this.contact.enamn = this.contactForm.value.enamn
      this.contact.epost = this.contactForm.value.epost

      // Update contact
      let cmd = { cmd: 'savecontact', system: this.db.system, token: this.db.token, contact: this.contact }
      encode(cmd)
      this.db.sendMessage('db', JSON.stringify(cmd))

    }

    var info = this.contactForm.value.info || ''
    if (info.length != 0) info += "\n"
    this.webOptions.filter(wo => wo.cbv).forEach(wo => {
      info += wo.cb
      if (wo.tbv != '-') info += ' ' + wo.tbv + ' st'
      info += '\n'
    })
    if (info.length > 0) {
      this.booking.internalinfo = "== Gästinfo från webbokning ==============\n" + info.trim() + "\n================================="
      this.booking.unfinished = true
    }

    if (this.extraprod1 > 0 || this.extraprod2 > 0 || this.extraprod3 > 0) {
      
      if (this.booking.internalinfo.length) this.booking.internalinfo += "\n"
      
      /*
      if (this.db.system == 'balthazar') {
        if (this.extraprod1 > 0) this.booking.internalinfo += this.extraprod1.toString() + " st Ost- & charkbricka med en flaska Crémant\n"
        if (this.extraprod2 > 0) this.booking.internalinfo += this.extraprod2.toString() + " st Chips & oliver med fyra öl\n"
      }
      */
      
      if (this.db.system == 'cabo') {
        //if (this.extraprod1 > 0) this.booking.internalinfo += this.extraprod1.toString() + " st Cava & jordgubbar\n"
        //if (this.extraprod2 > 0) this.booking.internalinfo += this.extraprod2.toString() + " st Ishink med 8 sol cerveza & nachos\n"
        //if (this.extraprod3 > 0) this.booking.internalinfo += this.extraprod3.toString() + " st Margaritas & sombreros\n"
        if (this.extraprod1 > 0) this.booking.internalinfo += this.extraprod1.toString() + " st Cava (Flaska)\n"
        if (this.extraprod2 > 0) this.booking.internalinfo += this.extraprod2.toString() + " st Sol\n"
        if (this.extraprod3 > 0) this.booking.internalinfo += this.extraprod3.toString() + " st Margaritas & sombreros\n"
      }

      if (this.db.system == 'cabotaqueria') {
        //if (this.extraprod1 > 0) this.booking.internalinfo += this.extraprod1.toString() + " st Margaritas & sombreros\n"
        //if (this.extraprod2 > 0) this.booking.internalinfo += this.extraprod2.toString() + " st Ishink med 8 sol cerveza & nachos\n"
        if (this.extraprod1 > 0) this.booking.internalinfo += this.extraprod1.toString() + " st Cava (Flaska)\n"
        if (this.extraprod2 > 0) this.booking.internalinfo += this.extraprod2.toString() + " st Sol\n"
        if (this.extraprod3 > 0) this.booking.internalinfo += this.extraprod3.toString() + " st Margaritas & sombreros\n"
      }

      if (this.db.system == 'namdo') {
        if (this.extraprod1 > 0) this.booking.internalinfo += this.extraprod1.toString() + " st Flaska vin\n"
        if (this.extraprod2 > 0) this.booking.internalinfo += this.extraprod2.toString() + " st Cocktail Xoaijito\n"
        if (this.extraprod3 > 0) this.booking.internalinfo += this.extraprod3.toString() + " st Alkoholfri Lychee Lychee\n"
      }

      if (this.db.system == 'nils') {
        if (this.extraprod1 > 0) this.booking.internalinfo += this.extraprod1.toString() + " st Glas Champagne\n"
        if (this.extraprod2 > 0) this.booking.internalinfo += this.extraprod2.toString() + " st Glas Moet med ost & chark\n"
      }      

      if (this.db.system == 'gustavadolf') {
        if (this.extraprod1 > 0) this.booking.internalinfo += this.extraprod1.toString() + " st Glas Bubbel\n"
        if (this.extraprod2 > 0) this.booking.internalinfo += this.extraprod2.toString() + " st Ost & chark för 2\n"
      }      
      
      this.tags.filter(t => t.name.toLowerCase() == 'extra').forEach(t => {
        this.booking.tags.push(t.id)
      })  
    }

    // Add contact to booking
    this.booking.contact = this.contact

    //var tagId = ''
    //this.tags.filter(t => t.name.toLowerCase() == 'web').forEach(t => {
    //  tagId = t.id
    //})
    //if (tagId != '') this.booking.tags.push(tagId)

    // Add 'web' tag
    this.tags.filter(t => t.name.toLowerCase() == 'web').forEach(t => { this.booking.tags.push(t.id) })

    // Add querystring tag
    if (this.db.addTag) this.tags.filter(t => t.sortorder == this.db.addTag).forEach(t => { this.booking.tags.push(t.id) })

    // Save booking
    this.db.socket.emit('nextbookingnr', { system: this.db.system }, (result) => {

      this.booking.nr = result.data.value.nr

      let cmd = { cmd: 'save', system: this.db.system, token: this.db.token, table: 'bookings', data: this.booking, workday: this.db.workday, id: this.booking.id }
      encode(cmd)
      this.db.sendMessage('db', JSON.stringify(cmd))
    
      // Create event
      this.createBookingEvent('Webbokning')

      // Send confirmations
      this.confirm()
      
    })

    this.steg = 5

    

    // Check if Swish is applicable
    this.checkSwish()

    // Kick
    setTimeout(() => { location.assign(this.db.setting.return); }, 30 * 1000)

  }

  ////////////////////////////////////////////////////////////////////////////
  //                                                                        //
  // Swish                                                                  //
  //                                                                        //
  ////////////////////////////////////////////////////////////////////////////

  checkSwish() {
    
    var allowpay = true
    
    this.db.booking.bookingItems.forEach(bi => {
      if (!bi.price) allowpay = false;
    })

    if (allowpay && this.db.setting.swishpay) this.swishable = true

  }

  betalaBtn() {
    this.router.navigateByUrl('/betala?uuid=' + this.db.booking.id);
  }

  ////////////////////////////////////////////////////////////////////////////
  //                                                                        //
  //                                                                        //
  //                                                                        //
  ////////////////////////////////////////////////////////////////////////////

  createBookingEvent(eventText) {
    
    var eventId = uuid()
    var now = new Date()

    this.db.sendMessage('dbm', { 
      cmd: 'save', 
      table: 'bookingevents', 
      system: this.db.system,
      data: { 
        id: eventId, 
        eventText: eventText,
        idBooking: this.booking.id,
        fnamn: this.booking.contact.fnamn,
        enamn: this.booking.contact.enamn,
        workday: this.booking.workday,
        persons: this.booking.persons,
        eventTime: now.format('YYYY-MM-DD HH:mm:ss'),
        signature: 'Web',
        system: this.db.system
      },
      id: eventId
    })

  }

  ////////////////////////////////////////////////////////////////////////////
  //                                                                        //
  // Booking confirmations                                                  //
  //                                                                        //
  // confirrmation.type: 0=Mail, 1=SMS, 2=Avbokningsmail, 3=AvbokningsSMS   //
  //                                                                        //
  ////////////////////////////////////////////////////////////////////////////

  getConfirmation(type): Confirmation {

    var confirmation

    var tmpResources = []
    this.booking.bookingItems.forEach(bi => {
      if (!tmpResources.filter(t => t == bi.idResource).length) tmpResources.push(bi.idResource)
    })
    //console.log('Resources in this booking', tmpResources)

    if (tmpResources.length == 1) {
      this.confirmations.filter(c => c.type == type && c.idResource == tmpResources[0]).forEach(c => {  
        confirmation = c
      })
    }

    if (!confirmation) this.confirmations.filter(c => c.type == type).forEach(c => { confirmation = c })

    return confirmation

  }

  confirm() {

    if (this.booking.bookingItems.length == 0 && this.booking.menuItems.length == 0) return

    var mailConfirmation = this.getConfirmation(0)
    var smsConfirmation = this.getConfirmation(1)

    // Check for confirmation from event
    this.booking.collapsedItems.filter(ci => ci.idEvent).forEach(ci => {
      this.events.filter(e => e.id == ci.idEvent).forEach(e => { 
        this.confirmations.filter(c => c.id == e.idConfirmation).forEach(c => { 
          mailConfirmation = c 
        })
      })
    })

    //if (this.db.system == 'dahlboms') {
    //  let chef = false
    //  this.booking.collapsedItems.filter(ci => ci.idEvent == '19430a00-b99d-11eb-812e-a1f75d26d2c9').forEach(ci => {
    //    chef = true
    //  })
    //  if (chef) var mailConfirmation = this.getConfirmation(6)
    //}

    if (!mailConfirmation || !smsConfirmation) return

    var mailObj = {
      cmd: 'sendmail',
      system: this.db.system,
      id: this.booking.id,
      subject: mailConfirmation.subject,
      to: this.booking.contact.epost,
      message: this.confirmationParser(this.booking, mailConfirmation.message),
      idMailAccount: mailConfirmation.idMailAccount,
      host: '',
      user: '',
      pass: '',
      from: ''
    }

    var smsObj = {
      cmd: 'sendsms',
      id: this.booking.id,
      sender: smsConfirmation.subject,
      to: this.fixMobile(this.booking.contact.mobil),
      message: this.confirmationParser(this.booking, smsConfirmation.message),
      system: this.db.system
    }    

    //console.log('SMS-Obj', smsObj)
    if (!['gastronome'].includes(this.db.system)) {
      if (smsObj.sender.length > 2) this.db.sendMessage('send', smsObj)
    }

    //console.log('mailObj', mailObj)
    this.db.sendMessage('send', mailObj)

    // Avisera
    this.db.setting.avismail.split(',').forEach(adr => {
      if (adr) {
        mailObj.to = adr
        mailObj.subject = "Ny webbokning"
        this.db.sendMessage('send', mailObj)
      }
    })

    this.db.setting.avissms.split(',').forEach(mob => {
      if (mob) {
        smsObj.to = this.fixMobile(mob)
        smsObj.message = "Ny webbokning: " + this.booking.workday + " " + this.confirmationParser(this.booking, '{bokningar}')
        this.db.sendMessage('send', smsObj)
      }
    })

  }

  confirmationParser(booking, template) {

    var keywords = template.toString().match(/\{.*?\}/g)

    if (keywords) keywords.forEach(keyword => {

      if (keyword == '{datum}') template = template.replaceAll('{datum}', booking.workday)
      if (keyword == '{nr}') template = template.replaceAll('{nr}', booking.nr)
      if (keyword == '{fnamn}') template = template.replaceAll('{fnamn}', booking.contact.fnamn)
      if (keyword == '{enamn}') template = template.replaceAll('{enamn}', booking.contact.enamn)
      if (keyword == '{epost}') template = template.replaceAll('{epost}', booking.contact.epost)
      if (keyword == '{mobil}') template = template.replaceAll('{mobil}', booking.contact.mobil)
      if (keyword == '{personer}') template = template.replaceAll('{personer}', booking.persons)
      if (keyword == '{avbokning}') template = template.replaceAll('{avbokning}', 'https://webbokning.bokad.se/avbokning/' + this.db.system + '/' + booking.id)

      var bokningar = ''
      var bokningar1 = ''
      var bokningar2 = ''
      
      booking.collapsedItems.forEach(ci => {
        
        var r = this.db.getResource(ci.idResource, this.resources)
        let name = r.name
        if (ci.idEvent) {
          this.events.filter(e => e.id == ci.idEvent).forEach(e => {
            name = e.descr
          })
        }
        
        bokningar += name + " kl " + this.db.minToTime(ci.start, ci.duration)
        bokningar1 += "Kl " + this.db.minToTime(ci.start, ci.duration)
        bokningar2 += name + " kl " + this.db.minToTime(ci.start)

        if (r.confirmationtype == 1) {
          bokningar += ", " + ci.bookingObjects.length + " " + (ci.bookingObjects.length == 1 ? r.unit.toLowerCase() : r.unitplural.toLowerCase()) + ". \n"
          bokningar1 += ", " + ci.bookingObjects.length + " " + (ci.bookingObjects.length == 1 ? r.unit.toLowerCase() : r.unitplural.toLowerCase()) + ". \n"
          bokningar2 += ", " + ci.bookingObjects.length + " " + (ci.bookingObjects.length == 1 ? r.unit.toLowerCase() : r.unitplural.toLowerCase()) + ". \n"
        }
        
        if (r.confirmationtype == 2 && booking.persons) {
          bokningar += ", " + booking.persons + " personer. \n"
          bokningar1 += ", " + booking.persons + " personer. \n"
          bokningar2 += ", " + booking.persons + " personer. \n"
        }

      })

      if (keyword == '{bokningar}') template = template.replaceAll('{bokningar}', bokningar)
      if (keyword == '{bokningar-kort}') template = template.replaceAll('{bokningar-kort}', bokningar1)
      if (keyword == '{bokningar-ejsluttid}') template = template.replaceAll('{bokningar-ejsluttid}', bokningar2)

      var parts = keyword.substring(1).slice(0, -1).split(':')

      if (parts.length == 3) {

        if (parts[0].toLowerCase() == 'om') {

          var replace = ''
          booking.collapsedItems.forEach(ci => {
            var words = parts[1].split(',')
            words.forEach(word => {
              if (this.db.getResource(ci.idResource, this.resources).name == word.trim()) replace = parts[2]
            })
          })

          template = template.replaceAll(keyword, replace)

        }

      }

    })
    
    return template

  }  

  fixMobile(nr) {
    nr = nr.replace(" ", "");
    nr = nr.replace("-", "");
    if (nr.substring(0, 1) == "0") nr = nr.substring(1);
    if (nr.substring(0, 3) != "+46") nr = "+46" + nr;
    return nr;
  }

  setPrices() {

    var d = new Date(this.db.workday);
    var n = d.getDay();
    if (n == 0) n = 7;
    n--;

    this.booking.bookingItems.forEach(bi => {

      var weekminute = n * 24 * 60 + bi.start;

      var price = 0;
      var vat = 0;
  
      this.prices.filter(p => p.idResource == bi.idResource).forEach(p => {
        if (weekminute >= p.from_min && weekminute <= p.to_min) {
          price = Math.round(p.price / this.db.getResource(bi.idResource, this.resources).defaultduration * bi.duration);
          var vatperc = p.vat / 100;
          var priceexcl = price / (1 + vatperc);
          vat = Math.round((price - priceexcl) * 100) / 100;
        }
      });
  
      bi.price = price;
      bi.vat = vat;

    });

  }

  isClosed() {
    var closed = true
    this.accordionItems.forEach(ai => {
      if (ai.open > 0) closed = false
    })
    return closed
  }

  extraprod1add(antal) {
    this.extraprod1 += antal
    if (this.extraprod1 < 0) this.extraprod1 = 0
    if (this.extraprod1 > 9) this.extraprod1 = 9
  }

  extraprod2add(antal) {
    this.extraprod2 += antal
    if (this.extraprod2 < 0) this.extraprod2 = 0
    if (this.extraprod2 > 9) this.extraprod2 = 9
  }

  extraprod3add(antal) {
    this.extraprod3 += antal
    if (this.extraprod3 < 0) this.extraprod3 = 0
    if (this.extraprod3 > 9) this.extraprod3 = 9
  }

  

}
